module.exports = "./img/b6d4538ef06c52de6d8b6f2093bc7e29.jpg";